import _ from 'lodash'

import { LevelPlayAtThePlace as Activity } from '.'

export const SLUG = 'at_the_place'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'verify',
    waitValidation: false,
    keepAnswer: true
  },
  handleAnswerCallback: props => {
    let { answer, activity } = props
    let { save_answer: saveAnswer, associations = [] } = activity.meta
    const leftAssociationExpressions = _.compact(
      _.get(associations, '0.expressions', [])
    ).sort()
    const rightAssociationsExpressions = _.compact(
      _.get(associations, '1.expressions', [])
    ).sort()

    let answerIsCorrect =
      _.isEqual(
        _.compact(leftAssociationExpressions).sort(),
        _.compact(answer['leftAssociationExpressions']).sort()
      ) &&
      _.isEqual(
        _.compact(rightAssociationsExpressions).sort(),
        _.compact(answer['rightAssociationsExpressions']).sort()
      )

    return { answer, answerIsCorrect, skipValidation: saveAnswer }
  },
  Component: Activity
}
